import { Toast } from "../shared/Toast"

export const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
        .then(() => {
            Toast("success", "Text copied Successfully");
        })
        .catch((err) => {
            Toast("error", "Failed to copy TEXT");
        });
};
